<template>
  <b-container fluid>
    <div class="card-main">
      <b-row>
        <b-col lg="3" sm="12" v-if="!is_edit">
          <b-button variant="success" @click="_addExperiencia()">
            <b-icon class="m-1" icon="building" aria-hidden="true"></b-icon>
            Adicionar Experiência Profissional
          </b-button>
        </b-col>
        <b-col lg="3" sm="12" v-if="user.experiencia_lines.length == 0">
          <b-alert variant="primary" show v-if="!is_edit">
            <b-form-group class="primeiro Emprego">
              <b-form-checkbox
                v-model="selected"
                @change="formSelected($event)"
                id="input-34"
                name="input-34"
              >
                Primeiro Emprego
              </b-form-checkbox>
            </b-form-group>
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="8" md="6" sm="12">
          <b-row v-if="!is_edit && user.experiencia_lines.length == 0">
            <b-col sm="12">
              <b-alert variant="danger" show>
                Informe todas as suas experiências profissionais anteriores,
                seja bem específico quanto as atividades desempenhadas
              </b-alert>
            </b-col>
          </b-row>

          <b-row v-if="!is_edit && user.experiencia_lines.length == 0">
            <b-col sm="12">
              <b-alert variant="warning" show>
                Toda informação é usada para filtrar o seu curriculo em busca da
                melhor vaga disponível
              </b-alert>
            </b-col>
          </b-row>

          <div v-if="is_edit">
            <b-row>
              <b-col lg="6" sm="12">
                <b-form-group label="Empresa" label-for="input-25">
                  <b-form-input
                    id="input-25"
                    v-model="exp.nome"
                    :state="
                      validation.hasError('exp.nome')
                        ? false
                        : exp.nome != ''
                        ? true
                        : null
                    "
                  ></b-form-input>
                  <div class="message">
                    {{ validation.firstError("exp.nome") }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col lg="6" sm="12">
                <b-form-group label="Ramo de Atividade" label-for="input-26">
                  <b-form-input
                    id="input-26"
                    v-model="exp.ramo_atividade"
                    :state="
                      validation.hasError('exp.ramo_atividade')
                        ? false
                        : exp.ramo_atividade != ''
                        ? true
                        : null
                    "
                  ></b-form-input>
                  <div class="message">
                    {{ validation.firstError("exp.ramo_atividade") }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="3" sm="12">
                <b-form-group label="Último Salário" label-for="input-27">
                  <b-form-input
                    class="form-control"
                    id="input-27"
                    type="number"
                    v-model="exp.ult_salario"
                    :state="
                      validation.hasError('exp.ult_salario')
                        ? false
                        : exp.ult_salario >= 1
                        ? true
                        : null
                    "
                  ></b-form-input>
                  <div class="message">
                    {{ validation.firstError("exp.ult_salario") }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col lg="4" sm="12">
                <b-form-group label="Último Cargo" label-for="input-28">
                  <b-form-input
                    id="input-28"
                    v-model="exp.cargo"
                    :state="
                      validation.hasError('exp.cargo')
                        ? false
                        : exp.cargo != ''
                        ? true
                        : null
                    "
                  >
                  </b-form-input>
                  <div class="message">
                    {{ validation.firstError("exp.cargo") }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col lg="5" sm="12">
                <b-form-group label="Tipo Registro" label-for="input-29">
                  <multiselect
                    id="input-29"
                    v-model="exp.tp_registo"
                    :options="tipoRegistro"
                    :multiple="false"
                    :preserve-search="true"
                    placeholder="Selecione uma opção"
                    track-by="nome"
                    label="nome"
                    :allow-empty="false"
                    :select-label="''"
                    :deselectLabel="''"
                    :selectedLabel="''"
                    required
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.nome }}</strong>
                    </template>
                  </multiselect>
                  <div class="message">
                    {{ validation.firstError("exp.tp_registo") }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="4" sm="12">
                <b-form-group label="Data de Admissão" label-for="input-30">
                  <b-input-group>
                    <b-form-input
                      class="form-control"
                      id="input-30"
                      v-mask="'##/##/####'"
                      autocomplete="off"
                      :state="
                        validation.hasError('exp.data_entrada')
                          ? false
                          : exp.data_entrada.length >= 10
                          ? true
                          : null
                      "
                      v-model="exp.data_entrada"
                    >
                    </b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="dateFormat"
                        button-only
                        right
                        aria-controls="input-4"
                        @context="dateEntradaFormatter($event, 'data_entrada')"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="message">
                    {{ validation.firstError("exp.data_entrada") }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col
                lg="4"
                sm="12"
                class="d-flex justify-content-center align-items-center"
              >
                <b-form-checkbox
                  v-model="dataAtualmente"
                  @change="formAtualmente($event)"
                  id="input-31"
                  name="input-31"
                >
                  <b-badge variant="success">Continuo Trabalhando</b-badge>
                </b-form-checkbox>
              </b-col>

              <b-col lg="4" sm="12">
                <b-form-group
                  v-if="!disableAtualmente"
                  label="Data de Demissão"
                  label-for="input-32"
                >
                  <b-input-group>
                    <b-form-input
                      class="form-control"
                      id="input-32"
                      v-mask="'##/##/####'"
                      autocomplete="off"
                      :state="
                        validation.hasError('exp.data_saida')
                          ? false
                          : exp.data_saida.length >= 10
                          ? true
                          : null
                      "
                      v-model="exp.data_saida"
                    >
                    </b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="dateSaidaFormat"
                        button-only
                        right
                        aria-controls="input-32"
                        @context="dateSaidaFormatter($event)"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="message">
                    {{ validation.firstError("exp.data_entrada") }}
                  </div>
                </b-form-group>
                <div
                  v-if="disableAtualmente"
                  style="height: 5ch; margin-top: 41px"
                >
                  <b-badge variant="info">Até o momento</b-badge>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12" sm="12">
                <b-form-group
                  v-if="!disableAtualmente"
                  label="Motivo Saída"
                  label-for="input-33"
                >
                  <b-form-input
                    id="input-33"
                    v-model="exp.motivo_saida"
                    :state="
                      validation.hasError('exp.motivo_saida')
                        ? false
                        : exp.motivo_saida != ''
                        ? true
                        : null
                    "
                  ></b-form-input>

                  <b-form-invalid-feedback id="input-live-feedback">
                    Descreva o Motivo da saída.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12" sm="12">
                <b-form-group
                  label="Atividades Realizadas"
                  label-for="input-34"
                >
                  <b-form-textarea
                    id="input-34"
                    v-model="exp.atividades"
                    rows="4"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12" sm="12">
                <b-form-group label="Já utilizou Máquinas / Equipamentos ?">
                  <b-form-radio
                    @change="formSelectedMaquinas($event)"
                    v-model="maquinaSelected"
                    name="some-maquinas-radios"
                    value="Sim"
                    id="sim-maquina"
                  >
                    Sim
                  </b-form-radio>
                  <b-form-radio
                    @change="formSelectedMaquinas($event)"
                    v-model="maquinaSelected"
                    name="some-maquinas-radios"
                    value="Nao"
                    id="nao-maquina"
                  >
                    Não
                  </b-form-radio>
                </b-form-group>
              </b-col>

              <b-col md="12" sm="12">
                <b-form-group
                  v-if="showMaquina"
                  label="Máquinas / Equipamentos"
                  label-for="input-35"
                >
                  <b-form-textarea
                    id="input-35"
                    v-model="exp.maquinas"
                    rows="4"
                  ></b-form-textarea>
                  <div class="message">
                    {{ validation.firstError("exp.maquinas") }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12" sm="12">
                <b-form-group label="Já utilizou Sistemas / OS's ?">
                  <b-form-radio
                    @change="formSelectedSistemas($event)"
                    v-model="sistemaSelected"
                    name="some-sistema-radios"
                    value="Sim"
                    id="sim-sistema"
                  >
                    Sim
                  </b-form-radio>
                  <b-form-radio
                    @change="formSelectedSistemas($event)"
                    v-model="sistemaSelected"
                    name="some-sistema-radios"
                    value="Nao"
                    id="nao-sistema"
                  >
                    Não
                  </b-form-radio>
                </b-form-group>
              </b-col>

              <b-col lg="12" sm="12">
                <b-form-group
                  v-if="showSistema"
                  label="Sistemas / OS's"
                  label-for="input-36"
                >
                  <b-form-textarea
                    id="input-36"
                    v-model="exp.sistemas"
                    rows="4"
                  ></b-form-textarea>
                  <div class="message">
                    {{ validation.firstError("exp.sistemas") }}
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="text-right">
                <b-button
                  class="m-1"
                  variant="warning"
                  @click="_cancelEditExp()"
                >
                  <b-icon-x-square></b-icon-x-square>
                  Cancelar
                </b-button>
                <b-button class="m-1" variant="success" @click="_salvarExp()">
                  <b-icon-file-earmark-check></b-icon-file-earmark-check>
                  Salvar
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <!-- Lista de Experiencias -->
        <b-col
          lg="4"
          md="6"
          sm="12"
          class="left-column-wrapper d-none d-md-block"
        >
          <b-row>
            <b-col class="text-center">
              <h6><b>Minhas Experiências Profissionais</b></h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              sm="12"
              v-for="(rows, index) in user.experiencia_lines"
              :key="rows.id"
            >
              <transition name="fade">
                <div class="mb-4">
                  <b-card style="border: 1px solid #e7e7e7">
                    <b-card-text>
                      <b>Empresa:</b> {{ rows.nome }} <br />
                      <b>Cargo:</b> {{ rows.cargo }} <br />
                      <b>Data Entrada:</b> {{ rows.data_entrada }}
                    </b-card-text>
                    <template v-slot:footer>
                      <b-btn
                        class="m-1"
                        @click="_editExp(index)"
                        variant="warning"
                      >
                        Editar
                      </b-btn>
                      <b-btn
                        class="m-1"
                        @click="_deleteExp(index)"
                        variant="danger"
                      >
                        Excluir
                      </b-btn>
                    </template>
                  </b-card>
                </div>
              </transition>
            </b-col>
          </b-row>
        </b-col>

        <!-- Lista de Experiencias Mobile -->
        <b-col
          lg="4"
          md="6"
          sm="12"
          class="left-column-wrapper d-md-none"
          v-if="!is_edit"
        >
          <b-row>
            <b-col class="text-center">
              <h3><b>Lista de EXP</b></h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              sm="12"
              v-for="(rows, index) in user.experiencia_lines"
              :key="rows.id"
            >
              <transition name="fade">
                <div class="mb-4">
                  <b-card style="border: 1px solid #e7e7e7">
                    <b-card-text>
                      <b>Empresa:</b> {{ rows.nome }} <br />
                      <b>Cargo:</b> {{ rows.cargo }} <br />
                      <b>Data Entrada:</b> {{ rows.data_entrada }}
                    </b-card-text>
                    <template v-slot:footer>
                      <b-btn
                        class="m-1"
                        @click="_editExp(index)"
                        variant="warning"
                      >
                        Editar
                      </b-btn>
                      <b-btn
                        class="m-1"
                        @click="_deleteExp(index)"
                        variant="danger"
                      >
                        Excluir
                      </b-btn>
                    </template>
                  </b-card>
                </div>
              </transition>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
/* eslint-disable no-console */
import CandidatoExperiencia from "../../model/CandidatoExperiencia";
import SimpleVueValidation from "simple-vue-validator";

const Validator = SimpleVueValidation.Validator;

SimpleVueValidation.extendTemplates({
  required: "Obrigatório",
  greaterThanOrEqualTo: "Infome/Escolha ao menos {0} opção.",
  length: "O tamanho mínimo é de {0} caracteres.",
  integer: "Infomre um valor inteiro (sem os centavos) - Somente o numero",
  greaterThan: "Informe um valor maior do que {0}.",
});

export default {
  data() {
    return {
      listaMobile: false,
      tipoRegistro: [
        { id: "C", nome: "CLT/Efetivo" },
        { id: "T", nome: "Temporário" },
        { id: "E", nome: "Estagiario" },
        { id: "S", nome: "Sem Registro" },
        { id: "D", nome: "Diarista" },
        { id: "O", nome: "Outros" },
      ],
      exp: new CandidatoExperiencia(),
      is_edit: false,
      position_array: -1,
      dataAtualmente: false,
      disableAtualmente: false,
      showMaquina: false,
      showSistema: false,
      checked: false,
    };
  },

  validators: {
    "exp.nome": function (value) {
      return Validator.value(value).required();
    },

    "exp.cargo": function (value) {
      return Validator.value(value).required();
    },

    "exp.ramo_atividade": function (value) {
      return Validator.value(value).required();
    },

    "exp.tp_registo": function (value) {
      return Validator.value(value.nome).required();
    },

    "exp.ult_salario": function (value) {
      return Validator.value(value).required().integer().greaterThan(1);
    },

    "exp.data_entrada": function (value) {
      return Validator.value(value)
        .required()
        .length(10)
        .custom(function () {
          var date = value;
          var ardt = new Array();
          var ExpReg = new RegExp(
            "(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}"
          );
          ardt = date.split("/");
          let erro = false;

          if (date.search(ExpReg) == -1) {
            erro = true;
          } else if (
            (ardt[1] == 4 || ardt[1] == 6 || ardt[1] == 9 || ardt[1] == 11) &&
            ardt[0] > 30
          )
            erro = true;
          else if (ardt[1] == 2) {
            if (ardt[0] > 28 && ardt[2] % 4 != 0) erro = true;
            if (ardt[0] > 29 && ardt[2] % 4 == 0) erro = true;
          }

          if (erro) return "Data Inválida";
        });
    },

    "exp.data_saida": function (value) {
      if (!this.dataAtualmente) {
        return Validator.value(value).required();
      }

      if (!this.dataAtualmente && this.exp.data_saida == "") {
        console.log("retorna erro");
        return "Campo Obrigatório";
      }

      if (this.dataAtualmente) {
        console.log("remove filtro");
        return Validator.value(value);
      }
    },

    selected: function (value) {
      return Validator.value(value).required();
    },

    "exp.maquinas": function (value) {
      if (this.maquinaSelected == "Sim") {
        return Validator.value(value).required();
      }

      if (this.maquinaSelected == "Sim" && this.exp.maquinas == "") {
        return "Descreva qual maquinario você já operou ou mude a opção para não.";
      }

      if (this.maquinaSelected == "Nao") {
        return Validator.value(value);
      }
    },

    "exp.sistemas": function (value) {
      if (this.sistemaSelected == "Sim") {
        return Validator.value(value).required();
      }

      if (this.sistemaSelected == "Sim" && this.exp.sistemas == "") {
        return "Descreva qual sistema você já operou ou mude a opção para não.";
      }

      if (this.sistemaSelected == "Nao") {
        return Validator.value(value);
      }
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
  },

  created: function () {
    this.selected = this.user.primeiro_emprego == 1 ? true : false;
  },

  methods: {
    dateEntradaFormatter(date) {
      if (!date.selectedYMD) return null;

      const [year, month, day] = date.selectedYMD.split("-");

      this.exp.data_entrada = `${day}/${month}/${year}`;
    },

    dateSaidaFormatter(date) {
      if (!date.selectedYMD) return null;

      const [year, month, day] = date.selectedYMD.split("-");

      this.exp.data_saida = `${day}/${month}/${year}`;
    },

    formAtualmente(event) {
      if (event) {
        this.exp.data_atualmente = "1";

        this.exp.data_saida = "";
        this.exp.motivo_saida = "";
        this.disableAtualmente = true;
        this.$validate();
      } else {
        this.exp.data_atualmente = "0";

        this.disableAtualmente = false;
      }
    },

    formSelectedSistemas(event) {
      let self = this;

      self.exp.experiencia_sistemas = event == "Sim" ? 1 : 0;
      self.sistemaSelected = event == "Sim" ? "Sim" : "Nao";

      if (self.exp.experiencia_sistemas == 1) {
        self.showSistema = true;
      } else {
        // this.exp.sistemas = "";
        self.showSistema = false;
      }
    },

    formSelectedMaquinas(event) {
      let self = this;

      self.exp.experiencia_maquinas = event == "Sim" ? 1 : 0;
      self.maquinaSelected = event == "Sim" ? "Sim" : "Nao";

      if (self.exp.experiencia_maquinas == 1) {
        self.showMaquina = true;
      } else {
        // this.exp.maquinas = "";
        self.showMaquina = false;
      }
    },

    formSelected(event) {
      let self = this;

      self.user.primeiro_emprego = event ? "Sim" : "Nao";
      self.selected = event ? true : false;

      if (self.user.primeiro_emprego == "Nao") {
        self.is_edit = true;
      } else {
        self.is_edit = false;
      }
    },

    _addExperiencia() {
      let self = this;

      self.validation.reset();

      this.is_edit = true;

      this.dataAtualmente = false;
      this.disableAtualmente = false;

      this.maquinaSelected = "Nao";
      this.showMaquina = false;

      this.sistemaSelected = "Nao";
      this.showSistema = false;

      this.selected = false;
      self.user.primeiro_emprego = "Nao";

      this.position_array = -1;
      this.exp = new CandidatoExperiencia();

      self.validation.reset();
    },

    _salvarExp() {
      let self = this;
      this.$validate().then(function (success) {
        if (success) {
          if (self.position_array < 0) {
            self.user.experiencia_lines.push(self.exp);
          } else {
            self.user.experiencia_lines[self.position_array] = self.exp;
          }
          self.is_edit = false;
        }
      });
    },

    _cancelEditExp() {
      let self = this;

      this.exp = new CandidatoExperiencia();
      this.is_edit = false;
      this.maquinaSelected = false;
      this.sistemaSelected = false;
      this.dataAtualmente = false;

      self.validation.reset();
    },

    _deleteExp(index) {
      let self = this;

      this.$swal({
        title: "Confirma a exclusão?",
        text: "Após a exclusão não será possivel recuperar os dados!",
        icon: "warning",
        showCloseButton: true,
        closeButtonAriaLabel: "Fechar",
        showCancelButton: true,
        confirmButtonText: "Sim, tenho certeza!",
        cancelButtonText: "Não, cancele!",
      }).then(function (isConfirm) {
        if (isConfirm.value) {
          self
            .$swal({
              title: "Excluido!",
              text: "item excluido com sucesso",
              icon: "success",
            })
            .then(function () {
              self.user.experiencia_lines.splice(index, 1);
            });
        }
      });
    },

    _editExp(index) {
      this.exp = this.user.experiencia_lines[index];

      if (this.exp.experiencia_maquinas == "1") {
        this.maquinaSelected = "Sim";
        this.showMaquina = true;
      } else {
        this.maquinaSelected = "Nao";
        this.showMaquina = false;
      }

      if (this.exp.experiencia_sistemas == "1") {
        this.sistemaSelected = "Sim";
        this.showSistema = true;
      } else {
        this.sistemaSelected = "Nao";
        this.showSistema = false;
      }

      if (this.exp.data_atualmente == "1") {
        this.dataAtualmente = true;
        this.disableAtualmente = true;
      } else {
        this.dataAtualmente = false;
        this.disableAtualmente = false;
      }

      this.position_array = index;
      this.is_edit = true;
    },
  },
  beforeMount() {},
  watch: {},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.message {
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  background: #fff;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: #3c3c3c;
  color: #17a2b8;
}

.left-column-wrapper {
  border-left: 5px solid #c7c7c7;
  border-radius: 5px;
}

@media (max-width: 430px) {
  .left-column-wrapper {
    border-right: 0px solid;
  }
}
</style>
